import React from "react";
import { motion } from "framer-motion";

const SecuritySettings = () => {
  const sections = [
    {
      title: "Password",
      desc: "Set a unique password to protect the account",
      action: <button className="btn btn-primary btn-sm">Change</button>,
    },
    {
      title: "Two Factor Authentication",
      desc: "Receive code via SMS or Email every login",
      action: <button className="btn btn-outline-primary btn-sm">Enable</button>,
    },
    {
      title: "Google Authentication",
      desc: "Connect to Google",
      action: (
        <div className="form-check form-switch">
          <input className="form-check-input" type="checkbox" defaultChecked />
        </div>
      ),
    },
    {
      title: "Phone Verification",
      desc: "Verified Mobile: +9344522524",
      action: (
        <>
          <button className="btn btn-outline-secondary btn-sm me-2">Remove</button>
          <button className="btn btn-primary btn-sm">Enable</button>
        </>
      ),
    },
    {
      title: "Email Verification",
      desc: "Verified Email: abc@example.com",
      action: (
        <>
          <button className="btn btn-outline-secondary btn-sm me-2">Remove</button>
          <button className="btn btn-primary btn-sm">Enable</button>
        </>
      ),
    },
    {
      title: "Device Management",
      desc: "Manage connected devices",
      action: <button className="btn btn-outline-secondary btn-sm">Manage</button>,
    },
    {
      title: "Deactivate Account",
      desc: "This will shutdown your account",
      action: <button className="btn btn-outline-warning btn-sm">Deactivate</button>,
    },
    {
      title: "Delete Account",
      desc: "Your account will be permanently deleted",
      action: <button className="btn btn-outline-danger btn-sm">Delete</button>,
    },
  ];

  return (
    <motion.div
      className="container py-3 card"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Security Settings
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >
        <div className="card-body">

          {sections.map((item, index) => (
            <motion.div
              key={index}
              className={`d-flex justify-content-between align-items-center py-3 ${
                index !== sections.length - 1 ? "border-bottom" : ""
              }`}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.08 }}
              whileHover={{ scale: 1.01 }}
            >
              <div>
                <h6 className="mb-1">{item.title}</h6>
                <small className="text-muted">{item.desc}</small>
              </div>

              <motion.div whileTap={{ scale: 0.9 }}>
                {item.action}
              </motion.div>
            </motion.div>
          ))}

        </div>
      </motion.div>
    </motion.div>
  );
};

export default SecuritySettings;